<template>
  <main-component />
</template>

<script>
import MainComponent from '@/components/Settings/index'

export default {
  components: {
    MainComponent
  },

  data () {
    return {
      modelName: 'settings'
    }
  }
}
</script>
